var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94785 8.63574C1.3198 8.63574 0 9.95554 0 11.5836C0 13.2116 1.3198 14.5314 2.94785 14.5314C4.5759 14.5314 5.89569 13.2116 5.89569 11.5836C5.89569 9.95554 4.5759 8.63574 2.94785 8.63574Z",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.381 8.63574C10.7529 8.63574 9.43311 9.95554 9.43311 11.5836C9.43311 13.2116 10.7529 14.5314 12.381 14.5314C14.009 14.5314 15.3288 13.2116 15.3288 11.5836C15.3288 9.95554 14.009 8.63574 12.381 8.63574Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8141 8.63574C20.186 8.63574 18.8662 9.95554 18.8662 11.5836C18.8662 13.2116 20.186 14.5314 21.8141 14.5314C23.4421 14.5314 24.7619 13.2116 24.7619 11.5836C24.7619 9.95554 23.4421 8.63574 21.8141 8.63574Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.4411a08358899a8ecf4024ce56676298.svg";
export { ForwardRef as ReactComponent };